import * as React from 'react';
import classNames from 'classnames';
import { Button, Radio, UIHeading4 } from '@cian/ui-kit';
import { useEventCallback } from '@cian/react-utils';
import { Modal } from '../../../../../../Modal';
import { IOption, TOptionValue } from '../../types';
import * as styles from './Popup.css';

interface IPopupProps {
  options: IOption[];
  value: TOptionValue;
  title?: string;
  onChange?(value: TOptionValue): void;
  onClose(): void;
}

export const Popup: React.VFC<IPopupProps> = ({ options, value: initialValue, title, onChange, onClose }) => {
  const [selectedValue, setSelectedValue] = React.useState(initialValue);

  const handleItemClick = useEventCallback(({ value, isTitle }: IOption) => () => {
    if (!isTitle) {
      setSelectedValue(value);
    }
  });

  const handleSubmit = useEventCallback(() => {
    if (onChange) {
      onChange(selectedValue);
    }

    onClose();
  });

  return (
    <Modal
      open
      title={title}
      footer={
        <div className={styles['footer']}>
          <Button fullWidth size="L" onClick={handleSubmit}>
            Применить
          </Button>
        </div>
      }
      onClose={onClose}
    >
      <ul className={styles['list']} role="listbox">
        {options.map(({ label, value, isTitle }, index) => {
          return (
            <li
              className={classNames(styles['item'], {
                [styles['is-title']]: isTitle,
              })}
              key={`${value}-${index}`}
              role="option"
              onClick={handleItemClick({ value, label, isTitle })}
            >
              {isTitle ? (
                <UIHeading4>{label}</UIHeading4>
              ) : (
                <Radio name="SelectMobile" checked={value === selectedValue} value={value} label={label} />
              )}
            </li>
          );
        })}
      </ul>
    </Modal>
  );
};
